
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';


@Injectable()
export class CargoApiInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req_url = req.url;

    function commonApiResponse(res,pgScanRespObj,dimensionMode,currentScan,nosqlScanRespObj=[],dimensionArr=[],measuredDimensionArr=[]){
      let pgDimensionObj={};
      let measuredResp=res["measured"];

      pgScanRespObj["dimensions"]={};
      pgScanRespObj["dimensions"]["dimension"] = dimensionArr;
      pgScanRespObj["dimensions"]["measuredDimension"] = measuredDimensionArr;
      pgScanRespObj["outOfBound"]=_.get(measuredResp, 'outOfBound', false) || false;

      if(environment.CERTIFIED_DISPLAY_ENABLED==="true" && res["certified"]){
        let certifiedResp = res["certified"];
        pgDimensionObj["length"]= _.get(certifiedResp, 'length.value', 0.0) || 0.0;// returned as cm
        pgDimensionObj["width"]= _.get(certifiedResp, 'width.value', 0.0) || 0.0;
        pgDimensionObj["height"]= _.get(certifiedResp, 'height.value', 0.0) || 0.0;
        pgDimensionObj["volumetricWeight"]= _.get(certifiedResp, 'volumetricWeight.value', 0.0) || 0.0;
      }else{
        pgDimensionObj["length"]= _.get(measuredResp, 'length.value', 0.0) || 0.0;// returned as cm
        pgDimensionObj["width"]= _.get(measuredResp, 'width.value', 0.0) || 0.0;
        pgDimensionObj["height"]= _.get(measuredResp, 'height.value', 0.0) || 0.0;
        pgDimensionObj["volumetricWeight"]= _.get(measuredResp, 'volumetricWeight.value', 0.0) || 0.0;
      }

      pgDimensionObj["skidHeight"]= _.get(pgScanRespObj, 'skidHeight', 0.0) || 0.0;
      pgDimensionObj["skidWeight"]= _.get(pgScanRespObj, 'skidWeight', 0.0) || 0.0;

      // if mesh volume enabled
      pgDimensionObj["measuredVolume"]= _.get(measuredResp, 'measuredVolume.value', 0.0) || 0.0;
      pgDimensionObj["cargoWeight"]= _.get(measuredResp, 'cargoWeight.value', 0.0) || 0.0;
      pgDimensionObj["source"]= 'CGE'; // always 'CGE'. 'API' is declared info
      pgDimensionObj["debugimage"]={};
      pgDimensionObj["debugimage"]['imageId'] = 'debug';

      pgDimensionObj["debugimage"]['url'] = dimensionMode == 1 ? nosqlScanRespObj["debugImage"] : res["debugImage"];

      // pgDimensionObj["debugimage"]['imageValue'] = nosqlScanRespObj["debugImage"];
      pgDimensionObj["changedDimensionFlag"]= false;
      pgDimensionObj["weight"]= _.get(measuredResp, 'weight.value', 0.0) || 0.0;
      pgDimensionObj["process"]= '';      // dont have in nosql request
      pgDimensionObj["locationCode"]=_.get(currentScan, 'locationCode', '') || '';
      pgDimensionObj["tiltable"]=_.get(currentScan, 'tiltable', false) || false;
      pgDimensionObj["stackable"]=_.get(currentScan, 'stackable', false) || false;
      pgDimensionObj["volume"]=pgDimensionObj["volumetricWeight"]*6000;
      pgDimensionObj["gunnyBags"]=_.get(currentScan, 'gunnyBags', false) || false;
      // pgDimensionObj["responseTime"]=pgScanReqObj["responseTime"] //dont have
      if(dimensionMode == 1){
        pgScanRespObj["dimensions"]["dimension"].push(pgDimensionObj)
      }else{
        pgScanRespObj["dimensions"]["dimension"]=[pgDimensionObj]
      }

      // if certified display is enabled, original measured values need to be preserved separately
      let certObj = dimensionMode == 1 ? nosqlScanRespObj["debugImage"] : res["debugImage"];
      if(environment.CERTIFIED_DISPLAY_ENABLED==="true" && certObj){
        pgScanRespObj["dimensions"]["measuredDimension"].push({
          "length": _.get(measuredResp, 'length.value', 0.0) || 0.0,
          "width": _.get(measuredResp, 'width.value', 0.0) || 0.0,
          "height": _.get(measuredResp, 'height.value', 0.0) || 0.0,
          "volumetricWeight": _.get(measuredResp, 'volumetricWeight.value', 0.0) || 0.0,
        })
      }
      console.log('pgScanRespObj', pgScanRespObj)
    }


    if(req_url.includes('cargo/scan/limit/') && req.method ==="POST"){
      try {
        // convert pg search object to nosql search object
        // console.log("getAllScans request"); // getAllScans request
        let pgSearchObj = req.body;
        let nosqlSearchObj ={
          "recordStatus": "AC"
        }
        if(Object.keys(pgSearchObj).includes('recordStatus')){
          nosqlSearchObj["recordStatus"]=pgSearchObj['recordStatus']
        }

        let searchfield = pgSearchObj["search"]
        if (searchfield && searchfield != null && searchfield != 'NA'){
          nosqlSearchObj["awbNumber"] = searchfield
        }
        if (pgSearchObj["aggregate"] === true) {
          nosqlSearchObj["aggregate"] = true;
        }
        req = req.clone({
          body: nosqlSearchObj,
          url: req.url,
          headers : req.headers.set('Accept', 'application/json'),
        });
      }
      catch(err){
        console.log("Error in parsing getAllScans request:", err);
      }
      return next.handle(req).pipe(
        map(event => {
          if (event instanceof HttpResponse) {
            try {
              // convert nosql scanrecord to pg scan record object
              // console.log("getAllScans response:", event.body)
              let responseField = event.body["response"]
              let getAllScansResponse
              let awbCountsMap = {}
              if (Array.isArray(responseField)) {
                getAllScansResponse = responseField
              } else {
                getAllScansResponse = (responseField && responseField["Cargos"]) || []
                awbCountsMap = (responseField && responseField["Counts"]) || {}
              }

              let pg_listOfScans=[]
              let pg_totalRowCount=0
              getAllScansResponse.forEach(function (scanRecord) {
                let pgScanRecord={}
                pgScanRecord["scanTransactionId"] = scanRecord["scanTransactionId"]
                pgScanRecord["awb"] = scanRecord["awbNumber"]
                pgScanRecord["createdDate"] = scanRecord["createDateTime"]
                pgScanRecord["updatedDate"] = scanRecord["updatedDateTime"]
                let countKey = scanRecord["awbNumber"] + "_" + scanRecord["scanTransactionId"];
                let awbCount = awbCountsMap[countKey];
                pgScanRecord["totalAwbPieces"] = awbCount != null ? awbCount : (_.get(scanRecord, 'totalPieces', 1) || 1);
                pgScanRecord["measuredPieces"] = _.get(scanRecord, 'count', 1) || 1;
                pgScanRecord["cargoeyeSystemId"] = scanRecord["cargoeyeSystemId"]
                pgScanRecord["consolidationWeight"] = _.get(scanRecord, 'consolidation.weight.value', 0) || 0;
                pgScanRecord["consolidationCount"] = _.get(scanRecord, 'consolidation.count', 1) || 1;
                pgScanRecord["outOfBound"]=_.get(scanRecord, 'outOfBound', false) || false;
                pgScanRecord["recordStatus"]=_.get(scanRecord, 'recordStatus', "-");
                // pgScanRecord["agentCode"] = scanRecord["x"] // in awb info (not required)

                let pgDimensionObj={}
                pgDimensionObj["tiltable"] = _.get(scanRecord, 'tiltable', false) || false;
                pgDimensionObj["stackable"] =  _.get(scanRecord, 'stackable', false) || false;
                let dimensionsType = environment.CERTIFIED_DISPLAY_ENABLED==="true" && scanRecord["certifiedDimensions"]? "certifiedDimensions" : "dimensions";
                let scanRecord_dimensions = scanRecord[dimensionsType];
                let db_length=_.get(scanRecord_dimensions, 'length.value', 0.0) || 0.0;
                let db_width=_.get(scanRecord_dimensions, 'width.value', 0.0) || 0.0;
                let db_height=_.get(scanRecord_dimensions, 'height.value', 0.0) || 0.0;
                pgDimensionObj["length"] = parseFloat((db_length/100).toFixed(4))
                pgDimensionObj["width"] = parseFloat((db_width/100).toFixed(4))
                pgDimensionObj["height"] = parseFloat((db_height/100).toFixed(4))
                pgDimensionObj["weight"] = _.get(scanRecord, 'weight.value', 0.0) || 0.0;
                pgDimensionObj["source"] =_.get(scanRecord, 'source', 'UI') || 'UI';
                pgDimensionObj["changedDimensionFlag"] = false;
                pgDimensionObj["debugimage"]={};
                pgDimensionObj["debugimage"]['imageId'] = 'debug';
                pgDimensionObj["debugimage"]['url'] = scanRecord["debugImage"];
                // pgDimensionObj["debugimage"]['imageValue'] = null;
                pgDimensionObj["skidHeight"] = parseFloat(((_.get(scanRecord, 'skidHeight.value', 0.0) || 0.0)).toFixed(4));
                pgDimensionObj["skidWeight"] = parseFloat(((_.get(scanRecord, 'skidWeight.value', 0.0) || 0.0)).toFixed(4));
                pgDimensionObj["dimensioningMode"] = parseInt(((_.get(scanRecord, 'dimensioningMode', 0) || 0)));
                pgDimensionObj["gunnyBags"]=_.get(scanRecord, 'gunnyBags', false) || false;
                pgDimensionObj["outOfBound"]=_.get(scanRecord, 'outOfBound', false) || false;
                pgDimensionObj["locationCode"] =  _.get(scanRecord, 'locationCode', '') || '';
                pgDimensionObj["cargoWeight"]= _.get(scanRecord, 'cargoWeight.value', 0.0) || 0.0;
                if(environment.MESH_VOLUME_ENABLED!=='true' && environment.CONSOLIDATION_SCAN_ENABLED!=='true'){
                  pgDimensionObj["volumetricWeight"] = parseFloat((db_length*db_width*db_height/6000).toFixed(2));
                }else{
                  pgDimensionObj["volumetricWeight"] = parseFloat((_.get(scanRecord, 'volumetricWeight.value', 0.0) || 0.0).toFixed(2));
                  pgDimensionObj["measuredVolume"] = parseFloat((_.get(scanRecord, 'measuredVolume.value', 0.0) || 0.0).toFixed(2));
                }
                // pgDimensionObj["responseTime"] = scanRecord["x"] //not in nosql
                pgDimensionObj["process"] = ''; //not in nosql, but required for scanForm
                pgScanRecord["dimensions"]={}
                pgScanRecord["dimensions"]["dimension"]=[pgDimensionObj]
                if(environment.CERTIFIED_DISPLAY_ENABLED==="true" && scanRecord["certifiedDimensions"]){
                  pgScanRecord["dimensions"]["measuredDimension"] = [{
                    "length": _.get(scanRecord["dimensions"], 'length.value', 0.0) || 0.0,
                    "width": _.get(scanRecord["dimensions"], 'width.value', 0.0) || 0.0,
                    "height": _.get(scanRecord["dimensions"], 'height.value', 0.0) || 0.0,
                    "volumetricWeight": _.get(scanRecord["dimensions"], 'volumetricWeight.value', 0.0) || 0.0,
                  }]
                }
                pg_listOfScans.push(pgScanRecord); // add to listOfScans field
                pg_totalRowCount+=1;  //increment totalRowCount (in postgres, this is the total scans in database, replaced with getTotalScansCount in nosql)
              });

              let pgResponse={}
              pgResponse["status_code"]=200;
              pgResponse["response"]={};
              pgResponse["response"]["listOfScans"]=pg_listOfScans
              pgResponse["response"]["totalRowCount"]=pg_totalRowCount

              event = event.clone({
                body: pgResponse
              });
              return event;
            }
            catch(err){
              console.log("Error in parsing getAllScans response:" , err);
            }
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            console.log("getAllScans error: ",error)
            return error;
          }
        })
      );
    }

    else if(req_url.includes('cargo/scan/') && req.method==="POST"){
      try {
        // console.log("scanCargo request");
        // convert pg scanCargo request (dimension_master/dimension) to nosql request object
        let pgScanReqObj = req.body;
        let nosqlScanReqObj={};
        let awbInfo={};
        awbInfo["awbNumber"]=pgScanReqObj["awb"]
        // awbInfo["receivedPieces"]=scan_pgobj["receivedPieces"] // additional field to return? (not required)
        awbInfo["totalPieces"]=_.get(pgScanReqObj, 'totalAwbPieces', 1) || 1;

        let scanInfo={}
        scanInfo["consolidation"]={}
        // scanInfo["consolidation"]["id"]= // to have an id generated in ui (not required, open item)
        scanInfo["consolidation"]["count"]=_.get(pgScanReqObj, 'consolidationCount', 1) || 1;
        scanInfo["consolidation"]["weight"]={}
        scanInfo["consolidation"]["weight"]["value"]=_.get(pgScanReqObj, 'consolidationWeight', 0.0) || 0.0;
        scanInfo["consolidation"]["weight"]["unit"]="kg"

        let currentScan={}
        scanInfo["currentScan"]={}
        currentScan["count"]=_.get(pgScanReqObj, 'measuredPieces', 1) || 1;
        currentScan["tiltable"]=_.get(pgScanReqObj, 'tiltable', false) || false;
        currentScan["stackable"]=_.get(pgScanReqObj, 'stackable', false) || false;
        currentScan["weight"]={}
        currentScan["weight"]["value"]=_.get(pgScanReqObj, 'weight', 0.0) || 0.0;
        currentScan["weight"]["unit"]="kg"
        currentScan["skidHeight"]={}
        currentScan["skidHeight"]["value"]=_.get(pgScanReqObj, 'skidHeight', 0.0) || 0.0;
        currentScan["skidHeight"]["unit"]="cm"
        currentScan["skidWeight"]={}
        currentScan["skidWeight"]["value"]=_.get(pgScanReqObj, 'skidWeight', 0.0) || 0.0;
        currentScan["skidWeight"]["unit"]="kg"
        currentScan["dimensioningMode"]=_.get(pgScanReqObj, 'dimensioningMode', 0) || 0;
        currentScan["locationCode"]=_.get(pgScanReqObj, 'locationCode', '') || '';
        currentScan["gunnyBags"]=_.get(pgScanReqObj, 'gunnyBags', false) || false;
        scanInfo["currentScan"]=currentScan

        let declaredDetails={};
        // declaredDetails["chargeableWeight"]={}
        // declaredDetails["chargeableWeight"]["unit"]="kg";
        // declaredDetails["chargeableWeight"]["value"] = null;
        // declaredDetails["volumetricWeight"]={}
        // declaredDetails["volumetricWeight"]["unit"]="kg";
        // declaredDetails["volumetricWeight"]["value"] = null;
        declaredDetails["weight"]={}
        declaredDetails["weight"]["unit"]="kg";
        declaredDetails["weight"]["value"] = pgScanReqObj["awbDeclaredWeightAPI"];
        declaredDetails["volume"]={}
        declaredDetails["volume"]["unit"]="kg";
        declaredDetails["volume"]["value"] = pgScanReqObj["awbDeclaredVolumeWeightFromAPI"];
        declaredDetails["pieces"] = pgScanReqObj["pieces"];

        nosqlScanReqObj["awbInfo"]=awbInfo;
        nosqlScanReqObj["scanInfo"]=scanInfo;
        nosqlScanReqObj["declaredDetails"]=declaredDetails;
        nosqlScanReqObj["userID"]=_.get(pgScanReqObj, 'userID', '');

        // nosqlScanReqObj["createDateTime"] = new Date().getUTCDate();
        // nosqlScanReqObj["updatedDateTime"] = new Date().getUTCDate();

        req = req.clone({
          body: nosqlScanReqObj,
          url: req.url,
          headers : req.headers.set('Accept', 'application/json'),
        });
      }
      catch(err){
        console.log("Error in parsing scanCargo request:", err);
      }
      return next.handle(req).pipe(
        map(event => {
          if (event instanceof HttpResponse) {
            try {
              let pgScanReqObj = req.body;
              let scanInfoObj=_.get(pgScanReqObj, 'scanInfo');
              let dimensionMode=scanInfoObj.currentScan.dimensioningMode;
              // convert nosql scan response to pg scan respose obj (dimension_master/dimension)
              let nosqlScanRespObj = event.body["response"]
              let MultiScanRespObj;
              let cargodetailsRes;
              if (nosqlScanRespObj["results"] && nosqlScanRespObj["results"].length>0){
                cargodetailsRes = nosqlScanRespObj["cargodetails"]
                nosqlScanRespObj = nosqlScanRespObj["results"][0];
                if(dimensionMode ==1 ){
                  MultiScanRespObj = event.body["response"]["results"]
                }
                // MultiScanRespObj = dimensionMode !=1 ? nosqlScanRespObj["results"][0] : nosqlScanRespObj["results"];
              }
              let nosqlScanReqObj = req.body; // can only access nosql request here, but not pgScanReqObj above
              let awbInfo =nosqlScanReqObj["awbInfo"]
              let scanInfo =nosqlScanReqObj["scanInfo"]
              let currentScan =scanInfo["currentScan"]
              let consolidation =scanInfo["consolidation"]

              let pgScanRespObj = {}
              pgScanRespObj["scanTransactionId"]=nosqlScanRespObj["scanTransactionId"]
              pgScanRespObj["transactionId"]=nosqlScanRespObj["scanTransactionId"]
              pgScanRespObj["awb"]=awbInfo["awbNumber"]
              pgScanRespObj["source"]='UI'
              pgScanRespObj["measuredPieces"]=currentScan["count"]
              // pgScanRespObj["cargoeyeSystemId"]=pgScanReqObj["source"]
              // pgScanRespObj["agentCode"]=pgScanReqObj["agentCode"]      //dont have
              // pgScanRespObj["responseTime"]=pgScanReqObj["responseTime"] //dont have
              pgScanRespObj["process"]= '';          // dont have in nosql request
              pgScanRespObj["locationCode"]=_.get(currentScan, 'locationCode', '') || '';
              pgScanRespObj["tiltable"]=_.get(currentScan, 'tiltable', false) || false;
              pgScanRespObj["stackable"]=_.get(currentScan, 'stackable', false) || false;
              pgScanRespObj["consolidationCount"]= _.get(consolidation, 'count', 1) || 1;
              pgScanRespObj["consolidationWeight"]= _.get(consolidation, 'weight.value', 0.0) || 0.0;
              pgScanRespObj["totalAwbPieces"]= awbInfo["totalPieces"]
              pgScanRespObj["skidHeight"]= parseFloat(((_.get(currentScan, 'skidHeight.value', 0.0) || 0.0)).toFixed(4)) //return to ui in meters
              pgScanRespObj["skidWeight"] = parseFloat(((_.get(currentScan, 'skidWeight.value', 0.0) || 0.0)).toFixed(4));
              pgScanRespObj["dimensioningMode"]= _.get(currentScan, 'dimensioningMode', 0) || 0;
              pgScanRespObj["gunnyBags"]=_.get(currentScan, 'gunnyBags', false) || false;
              pgScanRespObj["cargodetails"]=cargodetailsRes

              if(dimensionMode ==1){
                let dimensionParentArray = [];
                let measuredDimensionParentArray = [];
                MultiScanRespObj.map(res => {
                  commonApiResponse(res,pgScanRespObj,dimensionMode,currentScan,nosqlScanRespObj, dimensionParentArray, measuredDimensionParentArray);
                })
              }else{
                commonApiResponse(nosqlScanRespObj,pgScanRespObj,dimensionMode, currentScan);
              }

              pgScanRespObj["scanned_images"]=[]
              let scannedImages = nosqlScanRespObj["scannedImages"]
              scannedImages.forEach(function (image,index){
                let imageObj={}
                imageObj["imageId"]=_.get(image, 'imageId', index) || index;
                imageObj["imageValue"]=''
                imageObj["url"]=_.get(image, 'url', '') || '';
                pgScanRespObj["scanned_images"].push(imageObj);
              });

              let pgResponse={};
              pgResponse["status_code"]=200;
              pgResponse["response"]=pgScanRespObj;
              pgResponse["message"]= _.get(event.body, 'message', null) || null;

              event = event.clone({
                body: pgResponse
              });
              return event;
            }
            catch(err){
              console.log("Error in parsing scanCargo response:", err);
            }
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            console.log("scanCargo error:", error);
            return error;
          }
        })
      );
    }

    else if(req_url.includes('/cargo/awb/') && req.method==="PATCH"){
      try {
        // console.log("saveScan request")
        // convert pg update request (dimension_master/dimension) to nosql update request object
        let pgUpdateScanObj = req.body;

        let nosqlUpdateObj={}
        if(pgUpdateScanObj['awb']){ // check for awb=null
          nosqlUpdateObj["awbNumber"]=pgUpdateScanObj['awb']
        }
        if(pgUpdateScanObj['dimensions'] && pgUpdateScanObj['dimensions']['dimension']){
          let pgDimensionObj=pgUpdateScanObj['dimensions']['dimension'][0]
          nosqlUpdateObj["dimensions"]={}
          if(pgDimensionObj["length"]){
            nosqlUpdateObj["dimensions"]["length"]={"value": parseFloat((_.get(pgDimensionObj, 'length', 0.0) || 0.0).toFixed(2)) ,"unit": "cm"}
          }
          if(pgDimensionObj["width"]){
            nosqlUpdateObj["dimensions"]["width"]={"value": parseFloat((_.get(pgDimensionObj, 'width', 0.0) || 0.0).toFixed(2)) ,"unit": "cm"}
          }
          if(pgDimensionObj["height"]){
            nosqlUpdateObj["dimensions"]["height"]={"value": parseFloat((_.get(pgDimensionObj, 'height', 0.0) || 0.0).toFixed(2)) ,"unit": "cm"}
          }

          const weightValue = parseFloat(_.get(pgDimensionObj, 'weight', 0.0) as any) || 0.0;
          nosqlUpdateObj["weight"] = { "value": parseFloat(weightValue.toFixed(2)), "unit": "kg" };


          nosqlUpdateObj["count"]=_.get(pgDimensionObj, 'measuredPieces', 1) || 1;
          nosqlUpdateObj["tiltable"]=_.get(pgDimensionObj, 'tiltable', false) || false;
          nosqlUpdateObj["stackable"]=_.get(pgDimensionObj, 'stackable', false) || false;
          nosqlUpdateObj["locationCode"]=_.get(pgDimensionObj, 'locationCode', '') || '';
        }

        if(pgUpdateScanObj['recordStatus']){
          nosqlUpdateObj['recordStatus']=_.get(pgUpdateScanObj, 'recordStatus', 'AC') || 'AC';
        }

        if(pgUpdateScanObj['totalPieces']){
          nosqlUpdateObj['totalPieces']=pgUpdateScanObj['totalPieces'];
        }

        if(pgUpdateScanObj['cargodetails']){
          nosqlUpdateObj['cargodetails']=pgUpdateScanObj['cargodetails'];
        }

        if(pgUpdateScanObj['dimensionsEvents']){
          nosqlUpdateObj['dimensionsEvents']=pgUpdateScanObj['dimensionsEvents'];
        }

        if (typeof environment.AGGREGATE_PIECES === "string" && environment.AGGREGATE_PIECES.toLowerCase() === "true") {
          nosqlUpdateObj["aggregate"] = true;
        }

        req = req.clone({
          body: nosqlUpdateObj,
          url: req.url,
          headers : req.headers.set('Accept', 'application/json'),
        });
      }
      catch(err){
        console.log("Error in parsing updateScan request:", err);
      }
      return next.handle(req).pipe(
        map(event => {
          if (event instanceof HttpResponse) {
            return event;
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            console.log("saveScan error:", error);
            return error;
          }
        })
      );
    }

    // delete cargo not required to be intercepted
    // totalscancount not required to be intercepted

    // default for all other urls
    else{
      return next.handle(req).pipe(
        map(response => {
          if (response instanceof HttpResponse) {
            return response;
          }
        }, error => {
            if (error instanceof HttpErrorResponse) {
              console.log("error intercepted: ",error)
              return error;
            }
        })
      );
    }
  }
}
